module.exports = __webpack_public_path__ + "static/media/top issue.4779132d.png";